import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import React, { type FunctionComponent } from 'react';

interface FieldValueRemoveButtonProps {
  testId: string;
  onItemDelete: () => void;
  onItemBlur?: () => void;
  autoFocus?: boolean | undefined;
}

export const FieldValueRemoveButton: FunctionComponent<FieldValueRemoveButtonProps> = ({
  testId,
  onItemDelete,
  onItemBlur,
  autoFocus,
}) => {
  return (
    <IconButton
      testId={testId}
      appearance="subtle"
      icon={(iconProps) => <CrossIcon {...iconProps} size="medium" />}
      label=""
      onClick={onItemDelete}
      onBlur={onItemBlur}
      autoFocus={autoFocus}
    />
  );
};
